export default "__VITE_ASSET__b5d410b2__"